module.exports = "/_next/static/images/5b512908c7e6e3917f1779397b8122cf-NU_ComplianceTeam_ParkerLogo-08 1_md.png";